import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FullCalendar from "components/calendar/fullCalendar";
import { updateMeetingTime } from "redux/slices/meetingTimeSlice";
import style from "css/calendar.module.css";
import moment from "moment";
import axios from "axios";
import MeetingModal from "components/meeting/meetingModal";
import ResPop from "components/menu/resPop";
import ResDetailPop from "components/menu/resDetailPop";
import Mypagedetailpop from "components/mypagecomponents/mypagedetailpop";
import dayjs from "dayjs";
import { openAlert, closeAlert } from "redux/slices/alertSlice";
import { useTranslation } from "react-i18next";
/**
 * 파일명: calendar.js
 * 작성자: 강연승
 * 작성일자: 23.04.12
 * 설명: 캘린더 페이지
 */

function Calendar({ setType }) {
  //dispatch
  const dispatch = useDispatch();
  //translation
  const { t } = useTranslation();

  //selector
  const meetingTimePayload = useSelector((state) => state.meetingTime);
  const calendarRangePayload = useSelector((state) => state.calendarRange);

  //state
  const [scheduleList, setScheduleList] = useState([]);
  const [schedule, setSchedule] = useState({});
  const [scheduleType, setScheduleType] = useState("");

  const [isOpenRes, setIsOpenRes] = useState(false);
  const [isOpenResDetail, setIsOpenResDetail] = useState(false);

  const [pageType, setPageType] = useState("");
  useEffect(() => {
    const tmp = window.location.pathname.split("/");
    const pageName = tmp[tmp.length - 1];
    setPageType(pageName);
  }, []);

  const getSchedules = useCallback(() => {
    if (
      calendarRangePayload.ACTIVE_START !== "" &&
      calendarRangePayload.ACTIVE_END !== ""
    ) {
      let url = "/schedule/list";
      let param = {
        params: {
          ACTIVE_START: calendarRangePayload.ACTIVE_START + "T00:00:00",
          ACTIVE_END: calendarRangePayload.ACTIVE_END + "T00:00:00",
          CALENDAR_TYPE: "MY",
        },
      };
      // dispatch(openLoading());

      axios
        .get(url, param)
        .then((res) => {
          if (res.status === 200) {
            // dispatch(closeLoading());
            let schedules = [];
            schedules = res.data.SCHEDULE.map((data) => {
              return {
                id: data.SCHEDULE_ID,
                title: data.TITLE,
                start: data.START_TIME,
                end: data.END_TIME,
                backgroundColor:
                  data.SCHEDULE_TYPE === "CD0205" ? "#f1f8f6" : "#fcf6ee",
                borderColor:
                  data.SCHEDULE_TYPE === "CD0205" ? "#1cb691" : "#fd9800",
                // color: "#000",
                extendedProps: {
                  ...data,
                },
              };
            });
            setScheduleList(schedules);
          }
        })
        .catch(() => {
          // dispatch(closeLoading());
        });
    }
  }, [dispatch, calendarRangePayload]);

  useEffect(() => {
    getSchedules();
  }, [getSchedules]);

  /* eslint-disable no-useless-escape */
  const selectTime_bak = (time) => {
    const obj = {
      TYPE: "CALENDAR",
      VIEW: true,
      START_DATE: moment(time.startStr).format("YYYY-MM-DD"),
      END_DATE: moment(time.endStr).format("YYYY-MM-DD"),
      START_TIME: moment(time.startStr).format("HH:mm:ss"),
      END_TIME: moment(time.endStr).format("HH:mm:ss"),
    };
    dispatch(updateMeetingTime(obj));
  };

  const selectTime = (time) => {
    const obj = {
      TYPE: "CALENDAR",
      VIEW: true,
      START_DATE: time === "" ? "" : moment(time.startStr).format("YYYY-MM-DD"),
      END_DATE: time === "" ? "" : moment(time.endStr).format("YYYY-MM-DD"),
      START_TIME: time === "" ? "" : moment(time.startStr).format("HH:mm:ss"),
      END_TIME: time === "" ? "" : moment(time.endStr).format("HH:mm:ss"),
    };
    dispatch(updateMeetingTime(obj));

    setIsOpenRes(true);
    setSchedule(() => ({
      PROCESS_TYPE: "C",
      TITLE: "",
      CONTENTS: "",
      SCHEDULE_TYPE: scheduleType,
      OPEN_YN: "Y",
      RECORD_YN: "N",
      MEETING_PW: "",
      START_TIME:
        time === ""
          ? getReserveDateTime(new Date(), 0)
          : dayjs(time.startStr).format("YYYY-MM-DD HH:mm:ss"),
      END_TIME:
        time === ""
          ? getReserveDateTime(new Date(), 30)
          : dayjs(time.endStr).format("YYYY-MM-DD HH:mm:ss"),
      PARTICIPANT_LIST: [],
      ENDPOINT_LIST: [],
      MAIL_YN: "Y",
      ATTACHMENT_LIST: [],
    }));
  };

  const getSystemType = useCallback(() => {
    axios
      .get("/schedule/systemInfo")
      .then((res) => {
        if (res.status === 200) {
          setScheduleType(res.data.SYSTEM_TYPE);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getSystemType();
  }, [getSystemType]);

  const saveEventDrop = (info, type) => {
    let startTime;
    let endTime;
    if (type === "drop") {
      startTime = moment.utc(info.event.start).format("YYYY-MM-DD HH:mm:ss");
      endTime = moment.utc(info.event.end).format("YYYY-MM-DD HH:mm:ss");
    } else if (type === "resize") {
      startTime = moment.utc(info.oldEvent.start).format("YYYY-MM-DD HH:mm:ss");
      endTime = moment.utc(info.event.end).format("YYYY-MM-DD HH:mm:ss");
    }
    console.log(info);
    let params = {
      PROCESS_TYPE: "M",
      SCHEDULE_ID: info.event.id,
      SCHEDULE_TYPE: info.event.extendedProps.SCHEDULE_TYPE,
      TITLE: info.event.title,
      CONTENTS: info.event.extendedProps.CONTENTS,
      START_TIME: startTime,
      END_TIME: endTime,
      FILE_INFO: info.event.extendedProps.FILE_INFO,
      OPEN_YN: info.event.extendedProps.OPEN_YN,
      RECORD_YN: info.event.extendedProps.RECORD_YN,
      MAIL_YN: info.event.extendedProps.MAIL_YN,
      MEETING_PW: info.event.extendedProps.MEETING_PW,
      // PARTICIPANT_LIST: schedule.PARTICIPANT_LIST,
      // PARTICIPANT_ID_LIST: participantIdList,
      ENDPOINT_ID_LIST: [],
    };

    const formData = new FormData();
    formData.append("params", JSON.stringify(params));

    axios
      .put("/schedule/reserve", formData)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.MEETING_TIME_CHANGE"),
            submitEventHandler: () => {
              getSchedules();
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          // setLoading(false);
          // closePop();
        }
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
        // setLoading(false);
      });
  };

  const closeRes = () => {
    setScheduleId("");
    const obj = {
      TYPE: "",
      VIEW: false,
      START_DATE: "",
      END_DATE: "",
      START_TIME: "",
      END_TIME: "",
    };
    dispatch(updateMeetingTime(obj));
    setIsOpenRes(false);
  };

  const openResDetail = (Res) => {
    setIsOpenResDetail(true);
    setSchedule(Res);
  };
  const closeResDetail = () => {
    setIsOpenResDetail(false);
  };

  const [scheduleId, setScheduleId] = useState("");
  const [openDetailPopup, setOpenDetailPopup] = useState(false);
  const openScheduleDetail = (id) => {
    setScheduleId(id);
    setOpenDetailPopup(true);
  };
  const closeScheduleDetail = () => {
    setScheduleId("");
    setOpenDetailPopup(false);
  };

  const openRes = (Res) => {
    setIsOpenRes(true);
    setSchedule(Res);
  };

  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }

  return (
    <div className={style.wrapper}>
      <Mypagedetailpop
        open={openDetailPopup}
        close={closeScheduleDetail}
        SCHEDULE_ID={scheduleId}
        PAGE_TYPE={pageType}
        refresh={getSchedules}
        isOpenRes={(res) => {
          openRes(res);
        }}
      />
      <ResPop
        isOpenRes={isOpenRes}
        close={closeRes}
        setSchedule={setSchedule}
        schedule={schedule}
        getScheduleList={getSchedules}
      />
      <ResDetailPop
        isOpenResDetail={isOpenResDetail}
        close={closeResDetail}
        openRes={selectTime}
        schedule={schedule}
      />
      {/* <MeetingModal /> */}
      <FullCalendar
        scheduleList={scheduleList}
        selectTime={selectTime}
        eventClick={openScheduleDetail}
        saveEventDrop={saveEventDrop}
        setType={setType}
      />
    </div>
  );
}

export default Calendar;
